import React, { PureComponent } from 'react'
import { Modal, Col, Table, Button, Tooltip, OverlayTrigger } from 'react-bootstrap'
import { reduxForm, Field } from 'redux-form'
import InputTreeSelect from '../../commons/form/InputTreeSelect'
import IDocCarPagination from '../../commons/iDocCarPagination'
import { handleKeyDown } from '../../../util/utils'
class FinancingMasterModalUo extends PureComponent {
  constructor () {
    super()
    this.state = {
    }
  }

  submitFinancing (values) {
    this.props.actions.saveUoFinancingCompany(values.organizedUnitId, this.props.financing)
  }

  fetchFinancingList (value) {
    this.props.actions.openEditFinancingModalUo(this.props.financing, value, this.props.filter.pageSize, this.props.filter.orderBy)
  }

  getSortIcon (column = '') {
    switch (this.props.filter.orderBy) {
      case '+' + column:
        return 'ico-sort-selected-asc'
      case '-' + column:
        return 'ico-sort-selected-desc'
      default:
        return 'ico-sort'
    }
  }

  changeOrder (field) {
    switch (this.props.filter.orderBy) {
      case `+${field}`:
        this.props.actions.openEditFinancingModalUo(this.props.financing, this.props.page, this.props.filter.pageSize, `-${field}`)
        break
      case `-${field}`:
        this.props.actions.openEditFinancingModalUo(this.props.financing, this.props.page, this.props.filter.pageSize, `+${field}`)
        break
      default:
        this.props.actions.openEditFinancingModalUo(this.props.financing, this.props.page, this.props.filter.pageSize, `-${field}`)
        break
    }
  }

  UNSAFE_componentWillReceiveProps (nextProps) {
    if (nextProps.showModal !== this.props.showModal && nextProps.showModal === true) {
      this.props.initialize({ ...nextProps.financing })
    }
  }

  cleanUoCOmbo () {
    this.props.reset()
  }

  render () {
    const {
      t, handleSubmit,
      showModal, uoList, uoListCount, pagesCount, financing
      , combos: { UOTreeCombo }, actions: { deleteUoFinancingCompany, recoverUoFinancingCompany, closeEditFinancingModalUo }, filter: { page }
    } = this.props
    const tKey = 'MASTERS.FINANCING_MASTERS.MODAL_UO.'
    const deleteTooltip = (<Tooltip id="deleteTooltip">{t(`${tKey}DELETE`)}</Tooltip>)
    const recoverTooltip = (<Tooltip id="recoverTooltip">{t(`${tKey}RECOVER`)}</Tooltip>)
    const finName = financing && financing.name
    return (
      <Modal id="financingMasterModalUo" className="_nf" show={showModal} onHide={closeEditFinancingModalUo}>
        <form autoComplete="off" onSubmit={handleSubmit(this.submitFinancing.bind(this))} onKeyDown={(e) => handleKeyDown(e)}>
          <Modal.Header closeButton onHide={closeEditFinancingModalUo}>
            <Modal.Title>{t(`${tKey}TITLE`)} - {finName}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Table className="editable-table" hover responsive>
              <thead>
                <tr>
                  <th onClick={() => { this.changeOrder('name') }}>
                    {t(`${tKey}UO_NAME`)}
                    <i className={this.getSortIcon('name')} />
                  </th>
                  <th className='actions'>{t('DOSSIER_COMPONENTS.ACCESSORIES.ACTIONS')}</th>
                </tr>
              </thead>
              <tbody>
                {uoList && uoList.map((uo, idx) => {
                  return (
                    <tr key={idx} className={(uo.isDeleted ? 'is-deleted' : '')}>
                      <td>{uo.organizedUnit && uo.organizedUnit.name}</td>
                      <td className='actions'>
                        {!uo.isDeleted ? (
                          <div>
                            <OverlayTrigger placement="left" overlay={deleteTooltip}>
                              <a id="deleteUoFinancingCompany" className='_Btn cancel stk o-icn ' onClick={() => deleteUoFinancingCompany(uo.organizedUnitId, this.props.financing)}>
                                <i className="iDocIcon-delete-forever" />
                              </a>
                            </OverlayTrigger>
                          </div>
                        ) : (
                          <OverlayTrigger placement="left" overlay={recoverTooltip}>
                            <a id="restoreUoFinancingCompany" className='_Btn accent stk o-icn ' onClick={() => recoverUoFinancingCompany(uo.organizedUnitId, this.props.financing)}>
                              <i className='iDocIcon-undo-back' />
                            </a>
                          </OverlayTrigger>
                        )
                        }
                      </td>
                    </tr>
                  )
                })}
                {(uoList === null || uoList === undefined || uoList.length === 0) &&
                    <tr>
                      <td colSpan={4}><p className="no_results" >{t(`${tKey}RESULTS_NOT_FOUND`)}</p></td>
                    </tr>
                }

              </tbody>
            </Table>
            <div className="section-users-footer">
              <nav key={1} className="text-center">
                <IDocCarPagination
                  id="btn_pag_Uos"
                  page={page}
                  pagesCount={pagesCount}
                  totalRows={uoListCount}
                  onSelectAction={(value) => this.fetchFinancingList(value)}
                />
              </nav>
            </div>
            <div className="search-form inLine">
              <Field
                component={InputTreeSelect}
                colWidth={0} // 25, 33, 50, 75, 100 default=25
                name="organizedUnitId"
                controlLabel={t(`${tKey}ORGANIZED_UNIT`)}
                placeholder={t(`${tKey}ORGANIZED_UNIT`)}
                multi={true}
                valueKey="value"
                labelKey="label"
                childrenKey="children"
                options={UOTreeCombo}
                id="organizedUnitId"
              />
              <OverlayTrigger placement="left" overlay={deleteTooltip}>
                <a id="cleanUoCOmbo" className="_Btn cancel stk o-icn " onClick={() => this.cleanUoCOmbo()}>
                  <i className="iDocIcon-delete-forever" />
                </a>
              </OverlayTrigger>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Col sm={12} className="flexInLine al-R">
              <Button
                id="role-modal-submit-button"
                className="_Btn new"
                type="submit"
                disabled={this.props.pristine}>
                {t(`${tKey}SUBMIT_BUTTON`)}
              </Button>
            </Col>
          </Modal.Footer>
        </form>
      </Modal>
    )
  }
}

export default reduxForm({
  form: 'financingMasterModalUo'
})(FinancingMasterModalUo)
